import { OrganizationAdminShortList } from 'api/admin/models';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { EntityType } from 'store/entities/types';
import { actionsHandlers, stateFactories } from 'store/entities/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<OrganizationAdminShortList>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const adminAllOrganizationsReducer = createReducer<State, Actions>(initialState, {
  [actions.getAdminAllOrganizations.request.type]: actionsHandlers.handleGetManyRequest,
  [actions.getAdminAllOrganizations.success.type]: actionsHandlers.handleGetManySuccess,
  [actions.getAdminAllOrganizations.failure.type]: actionsHandlers.handleGetManyFailure,
  [actions.getAdminAllOrganizations.reset.type]: actionsHandlers.handleGetManyReset,
});

export default adminAllOrganizationsReducer;
